import React, { useEffect, useRef, useState } from 'react';
import './preChat.css';
import PhoneInput from 'react-phone-input-2'
import './phoneInput.css';
import { delay, getUserId, truncateString } from '../utils/helper';
import parsePhoneNumberFromString from 'libphonenumber-js';
import WebSocketManager from '../manager/WebSocketManager';

const webSocketManager = new WebSocketManager();
function PreChat({ data, onFormSubmit, buttonColor, colors, config }) {
  const loadingRef = useRef(false);

  const [formData, setFormData] = useState({});
  const [countryCode, setCountryCode] = useState('');
  const [errors, setErrors] = useState({});
  const [submitFlag, setSubmitFlag] = useState(false);
  const validate = (obj) => {
    const newErrors = data?.surveyFields.reduce((acc, item) => {
      const value =
        item.type === 'email_consent' || item.type === 'gdpr_consent'
          ? obj[item.type]
          : obj[item.type]?.trim();

      if (item.type === 'name') {
        if (!obj[item.type]?.trim()) {
          acc[item.type] = 'Name is required.';
        } else if (obj[item.type].length < 3) {
          acc[item.type] = 'Name must be at least 3 characters.';
        } else if (obj[item.type].length > 50) { // Set max length
          acc[item.type] = 'Name cannot exceed 50 characters.';
        }
      }

      // Email validation
      if (item.type === 'email') {
        if (!obj[item.type]) {
          acc[item.type] = 'Email is required.';
        } else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(obj.email)) {
          acc[item.type] = 'Email address is invalid.';
        } else if (obj[item.type].length > 50) { // Set max length
          acc[item.type] = 'Email cannot exceed 50 characters.';
        }
      }

      // Phone validation
      if (item.type === 'phone') {
        if (!obj[item.type]) {
          acc[item.type] = 'Phone number is required.';
        } else {
          try {
            const country = countryCode?.toUpperCase();

            // Parse the phone number using libphonenumber-js
            const parsedNumber = parsePhoneNumberFromString(obj[item.type], country);
      
            if (!parsedNumber || !parsedNumber.isValid()) {
              acc[item.type] = 'Invalid phone number.';
            } else if (parsedNumber.country !== country) {
              acc[item.type] = `Phone number does not match country code ${country}.`;
            } else if ((obj[item.type]).length + 1 !== parsedNumber.number.length) {
              acc[item.type] = `Invalid phone number length for ${country}.`;
            }
          } catch (error) {
            acc[item.type] = 'Invalid phone number format.';
          }
        }
      }


      // if (!obj[item.type] && item.required) {
      //   acc[item.type] = `${item.value} is required`;
      // }

      return acc;
    }, {});

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const data = {
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    };
    setFormData(data);
    setErrors({
      ...errors,
      [name]: '' // Clear the error for the current field when it is changed
    });
    if(submitFlag) validate(data);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    handlePrechatSubmit();
  };

  const handlePrechatSubmit = async () => {
    if(navigator?.onLine && !loadingRef.current) {
      setSubmitFlag(true);
      if (validate(formData)) {
        loadingRef.current = true;
        onFormSubmit(false);
        await delay(500);
        const ID = getUserId(config.widgetId)
        const messageToSend = {
          id: ID,
          payloadType: 'message',
          type: 'prechat',
          from: 'customer',
          content: {
            prechat: {
              userInfo: {
                name: formData.name,
                email: formData.email,
                phoneNumber: formData.phone,
                email_consent: formData?.email_consent,
                gdpr_consent: formData?.gdpr_consent
              }
            }
          }
        };

        webSocketManager.send(messageToSend);

        setSubmitFlag(false);

        setTimeout(() => {
          loadingRef.current = false;
        }, 1000);
      } 
    } else {
      alert("Please check your internet connection and try again")
    }
  }
  useEffect(() => {
    webSocketManager.addListener('open', () => setFormData({}));
    return () => {
      webSocketManager.removeListener('open', () => setFormData({}));
    };
  }, []);
  
  return (
    <div>
      <div className="form-body">
        <div className='rcw-boy-title'>{truncateString(data?.message, 45)}</div>
        <form onSubmit={handleSubmit}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              const isPhoneInput = document.activeElement.classList.contains('phone-input');
              if (isPhoneInput) {
                handleSubmit(e); // Prevent Enter key from submitting the form in the phone input
              }
            }
          }}
        >
          {data?.surveyFields.map((item, index) => (
            <div key={index} className="form-control">
              <div>
                {item.type === 'email_consent' || item.type === 'gdpr_consent' ? (
                  <div>
                    <input
                      type="checkbox"
                      id={`input-${item.type}`}
                      name={item.type}
                      value={formData[item.type] || ''}
                      onChange={handleChange}
                      className="form-control"
                    />
                    <label style={{ display: 'contents' }}>
                      {item.type === 'gdpr_consent' ? item.value : 'Signup for Newsletter'}
                    </label>
                  </div>
                ) : item.type === 'phone' ?
                  <PhoneInput
                    country={'us'}
                    value={formData[item.type]}
                    className="phone-input"
                    placeholder={truncateString(item.value, 20)}
                    onChange={(phone, country) => {
                      const data = {
                        ...formData,
                        [item.type]: phone
                      }
                      setCountryCode(country.countryCode)
                      setFormData(data)
                      if(submitFlag) validate(data);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        handleSubmit(e); // Prevent form submission
                      }
                    }}
                    style={{ border: errors[item.type] ? "1px solid #FD5757" : "", borderRadius: '10px' }}
                  /> : (
                    <div
                      className="input-fields">
                      <input
                        type="text"
                        id={`input-${item.type}`}
                        name={item.type}
                        placeholder={truncateString(item.value, 20)}
                        value={formData[item.type] || ''}
                        onChange={handleChange}
                        className="form-control"
                        style={{ border: errors[item.type] ? "1px solid #FD5757" : "" }}
                      />
                    </div>
                  )}
                {errors[item.type] && (
                  <div className="error-message">
                    {errors[item.type]}
                  </div>
                )}
              </div>
            </div>
          ))}
          <button
            disabled={loadingRef.current}
            style={{ 
              backgroundColor: buttonColor, 
              color: colors, 
              border: buttonColor === "#ffffff" ? '1px solid #dddddd' : '',
              opacity: loadingRef.current ? 0.6 : 1,
              pointerEvents: loadingRef.current ? 'none' : 'auto'
            }}
            type="submit"
            value="submit"
            className="submit-button">
            {loadingRef.current ? "Submitting..." : "Submit"}
          </button>
        </form>
      </div>
    </div>
  );
}
export default PreChat;
